export const SEARCH_APPOINTMENTS_LIMIT = 7;
export const APPOINTMENT_OFFSET_MINUTES = 60;
export const APPOINTMENT_CANCELLABLE_OFFSET_MINUTES = 15;
export const PAYMENT_INSTALLMENTS_NUMBER = 2;
export const PAYMENT_PIX_OFFSET_MINUTES = 15;
